export const actorInfo = {
  name: 'Jordan Destin',
  tagline: 'Film & Television Actor',
  height: '6\'3"',
  location: 'Los Angeles, CA',
  representation: 'MMPR GROUP',
  agent: 'MMPR GROUP',
  agentEmail: 'teammmprg@gmail.com',
  agentPhone: '(323) 229-8498',
  secondRepresentation: 'TDH TALENT',
  secondAgent: 'Tonya Hensley',
  secondAgentEmail: 'tonya.hensley@tdhtalent.com',
  secondAgentPhone: '(404) 435-2080',
};

export const bioText = {
  intro: 'Jordan Destin (born June 11 in Orléans, France) is a French-American actor, producer, and writer known for his versatile performances across film and television. Raised in a family of engineers, Destin\'s early passion for the performing arts set him on an unconventional path. Encouraged by his mother, he began acting classes at age 11, appearing in short films and music videos throughout his youth.',
  background: 'At 18, he moved to New York to pursue creative opportunities, debuting as a print model before traveling the world. He eventually relocated to California to follow his lifelong dream of acting, studying under prominent teachers and honing his craft in improv and studio training. He is a member of SAG-AFTRA.',
  recent: 'Destin\'s on-screen career spans a wide range of roles in both independent and mainstream projects. He has appeared in feature films such as The Devil\'s Fortune (2022), where he played Rukan, and is slated to appear in Little Miss Sociopath (2025) as Robert Marlow. His early screen work includes roles in Silver Age (2020), Red Carpet (2021), and cameo appearances in larger films like Zeroville and Seberg (both 2019). On television, he has guest-starred in series like Rogue (2023) and Huge in France (2019).',
  approach: 'In addition to acting, Destin is expanding his creative footprint behind the camera. He served as actor, executive producer, and writer on the 2024 TV mini-series Foolproof and continues to build his body of work with diverse upcoming projects, showcasing his range from dramatic to character-driven roles. Standing at 6′3″ and fluent in both French and English, Destin brings an international presence and eclectic experience to his work, blending European depth with Hollywood sensibilities.',
};

export const skills = [
  { category: 'Improvisation', training: 'Groundlings Theatre' },
  { category: 'Voice Acting', training: 'Private Coaching' },
  { category: 'Horseback Riding', training: 'Advanced Level' },
  { category: 'Shooting', training: 'Proficient' },
  { category: 'French', training: 'Fluent' },
];

export const pressItems = [
  {
    id: 1,
    publication: 'Variety',
    headline: 'Rising Star Jordan Destin Shines in Midnight Chronicles',
    excerpt: 'Destin delivers a powerhouse performance that anchors the entire series. Their ability to convey complex emotions with subtlety is remarkable.',
    date: 'December 2024',
    logo: 'https://public.readdy.ai/ai/img_res/d4c7ece2b9911b7076f89332de8b3b42.jpg',
  },
  {
    id: 2,
    publication: 'The Hollywood Reporter',
    headline: 'The Last Summer: A Breakthrough Performance',
    excerpt: 'Jordan Destin proves they are one of the most talented actors of their generation with a nuanced, heartbreaking portrayal.',
    date: 'November 2024',
    logo: 'https://readdy.ai/api/search-image?query=hollywood%20reporter%20magazine%20logo%20clean%20white%20background%20professional%20entertainment%20publication&width=200&height=80&seq=press2&orientation=landscape',
  },
  {
    id: 3,
    publication: 'IndieWire',
    headline: 'Sundance Standout: Destin Captivates Audiences',
    excerpt: 'In a festival filled with strong performances, Destin stands out with their raw, authentic approach to a challenging role.',
    date: 'January 2024',
    logo: 'https://readdy.ai/api/search-image?query=indiewire%20publication%20logo%20clean%20white%20background%20minimalist%20film%20industry%20magazine&width=200&height=80&seq=press3&orientation=landscape',
  },
  {
    id: 4,
    publication: 'Deadline',
    headline: 'Jordan Destin Signs Major Studio Deal',
    excerpt: 'Following their acclaimed performances, Destin has signed a multi-picture deal with a major studio, cementing their status as a leading talent.',
    date: 'October 2024',
    logo: 'https://readdy.ai/api/search-image?query=deadline%20hollywood%20logo%20clean%20white%20background%20professional%20entertainment%20news%20publication&width=200&height=80&seq=press4&orientation=landscape',
  },
  {
    id: 5,
    publication: 'Entertainment Weekly',
    headline: 'The Actors to Watch This Year',
    excerpt: 'Destin tops our list of must-watch performers. Their range and dedication to craft make them one of the most exciting talents working today.',
    date: 'September 2024',
    logo: 'https://readdy.ai/api/search-image?query=entertainment%20weekly%20magazine%20logo%20clean%20white%20background%20professional%20pop%20culture%20publication&width=200&height=80&seq=press5&orientation=landscape',
  },
  {
    id: 6,
    publication: 'Los Angeles Times',
    headline: 'Stage to Screen: Destin\'s Seamless Transition',
    excerpt: 'With a strong theater background, Destin brings a level of craft and preparation that elevates every project they touch.',
    date: 'August 2024',
    logo: 'https://readdy.ai/api/search-image?query=los%20angeles%20times%20newspaper%20logo%20clean%20white%20background%20professional%20news%20publication&width=200&height=80&seq=press6&orientation=landscape',
  },
];

export const pullQuote = {
  text: 'Jordan Destin is a force of nature. Their performance is nothing short of extraordinary.',
  critic: 'Peter Travers',
  publication: 'Rolling Stone',
};

export const galleryImages = [
  {
    id: 1,
    url: 'https://www.dropbox.com/scl/fi/od6dvt7dtercpixfxjob3/Jordan-Destin.jpeg?rlkey=26o1xd5xh8g1p8yogn1amsc8l&st=eqmrdava&raw=1',
    category: 'Headshots',
    title: 'Professional Headshot',
    size: 'large',
  },
  {
    id: 2,
    url: 'https://www.dropbox.com/scl/fi/wsrd1rr3o2jldgu7cw0w2/Jordandestin001.png?rlkey=fiy5frwsm2twda4oa9d8wbwwu&st=itq59v75&raw=1',
    category: 'Production Stills',
    title: 'Production Still',
    size: 'wide',
  },
  {
    id: 3,
    url: 'https://www.dropbox.com/scl/fi/ipnq2s5dbqjtsfkmhb4mg/JordanDestin-ProductionStills001.png?rlkey=qo0dtttoaccd2191hrmymr95h&st=o1ne5770&raw=1',
    category: 'Production Stills',
    title: 'Production Still',
    size: 'wide',
  },
  {
    id: 4,
    url: 'https://www.dropbox.com/scl/fi/1ygdkz4l0wfk5bk601i0h/JordanDestin_DestinFilms.jpg?rlkey=6usw1z2isbnu27yynjrp31mk2&st=twemp6vd&raw=1',
    category: 'Headshots',
    title: 'Professional Portrait',
    size: 'large',
  },
  {
    id: 5,
    url: 'https://www.dropbox.com/scl/fi/ph9xa1gkq6jo8ivk6wvng/JordanDestin-Napoleon-Skittles.png?rlkey=p0ht3pyji476eqay2dush6uxu&st=40phvmhg&raw=1',
    category: 'Headshots',
    title: 'Character Study',
    size: 'small',
  },
  {
    id: 6,
    url: 'https://www.dropbox.com/scl/fi/38ykbh0tea3lum5gx8j1m/Jordandestin-productionstill002.png?rlkey=3lvf4vxrun4azb8vnsodglhwv&st=j5kgu5g0&raw=1',
    category: 'Production Stills',
    title: 'Period Drama',
    size: 'small',
  },
  {
    id: 7,
    url: 'https://www.dropbox.com/scl/fi/y2qff0zmft8r9mctbm17r/Jordan_Destin.jpeg?rlkey=v5wyqalm2djr1sqn8nwa19pq3&st=m7t3i8ar&raw=1',
    category: 'Headshots',
    title: 'Natural Light',
    size: 'large',
  },
  {
    id: 8,
    url: 'https://www.dropbox.com/scl/fi/hk0718mu1lyfga9myuvuq/Jordandestin.jpg?rlkey=sawhf7iiae42lcczlgpedqpb0&st=hehjc62w&raw=1',
    category: 'Behind the Scenes',
    title: 'Script Reading',
    size: 'small',
  },
  {
    id: 9,
    url: 'https://www.dropbox.com/scl/fi/xqdx6wl6hygjyu7xepsrw/Jordandestin-Headshot003.JPG?rlkey=5wi8kvayqb84irsptz2q7igdr&st=oq0lyytm&raw=1',
    category: 'Headshots',
    title: 'Classic Portrait',
    size: 'small',
  },
];